export default function getChatSubProduct(quote, requestInfo) {
  if (requestInfo?.sanitaria_stranieri?.is_resident == 1) {
    return 'sanitaria_stranieri_resident';
  }
  if (quote?.quotation_data_travel_europeassistance && quote?.quotation_data_travel_europeassistance?.product_code === 'EA0177') {
    return 'viaggi_europa';
  }

  if (quote?.quotation_data_travel_europeassistance && quote?.quotation_data_travel_europeassistance?.product_code === 'EA0190') {
    return 'viaggi_mondo';
  }

  return quote?.sub_product;
}
